<template>
    <div>
        <Modal v-model="modal" :title="!patchBaselineForm.id ? this.$t('patch_management.patch_policy.addPatchBaseline'):this.$t('patch_management.patch_policy.editPatchBaseline')" @on-cancel="cancel('patchBaselineForm')" @on-ok="ok('patchBaselineForm')"  :loading="loading" :mask-closable="false" width="600px" :okText="!patchBaselineForm.id ? this.$t('patch_management.patch_policy.add'):this.$t('patch_management.patch_policy.edit')" :cancelText="$t('alarms.common.cancel')">
            <Form ref="patchBaselineForm" :model="patchBaselineForm" :label-width="100" :rules="ruleValidate" >
                <!-- 名称 -->
                <FormItem :label="$t('patch_management.patch_policy.title')"  prop="name">
                    <Input type="text" v-model="patchBaselineForm.name" placeholder="" style="width:300px;"></Input>
                </FormItem>

                <!-- 账号 -->
                <FormItem :label="$t('patch_management.patch_policy.account')" prop="accountIdSearchKey">
                    <Select v-model="patchBaselineForm.accountIdSearchKey" filterable placeholder=""  @on-change="changeAccountId(patchBaselineForm.accountIdSearchKey)" :transfer="true" style="width:300px; ">
                        <Option :value="item.id" v-for="item in accountIdList" :key="item.id">{{item.name}}</Option>
                    </Select>
                </FormItem>

                <!-- 区域 -->
                <FormItem :label="$t('patch_management.patch_policy.region')" prop="regionSearchKey">
                    <Select v-model="patchBaselineForm.regionSearchKey" filterable placeholder="" :transfer="true" style="width:300px;" @on-change="changeRegionSearchKey(patchBaselineForm.regionSearchKey)" >
                        <Option :value="item.name" v-for="item in regionList" :key="item.id">{{item.name}}</Option>
                    </Select>
                </FormItem>

                <!-- 操作系统 -->
                <FormItem :label="$t('patch_management.patch_policy.os')" prop="operatingSystem" >
                    <Select v-model="patchBaselineForm.operatingSystem" style="width:300px;" :transfer="true" @on-change="changeOperatingSystem(patchBaselineForm.operatingSystem)" >
                        <Option :value="item.operatingName" v-for="(item,index) in operatingSystemList" :key="index">{{item.name}}</Option>
                    </Select>
                </FormItem>

                <!-- 默认补丁基准 -->
                <FormItem :label="$t('patch_management.patch_policy.defaultBaseline')" prop="isDefault">
                    <RadioGroup v-model="patchBaselineForm.isDefault">
                        <Radio v-for="list in isDefaultList" :label="list.isDefault" :key="list.value">{{list.label}}</Radio>
                    </RadioGroup>
                </FormItem>

                <!-- 产品 -->
                <FormItem :label="$t('patch_management.patch_policy.product')" prop="products">
                    <Select v-model="patchBaselineForm.products" multiple :max-tag-count="1" @on-change="productsChange(patchBaselineForm.products)" style="width:300px;" placeholder="">
                        <Checkbox v-model="singleProducts" @on-change="selectProductsAll" style="display: block;text-align:right;">{{ $t('patch_management.patch_policy.selectAll') }} </Checkbox>
                        <Option v-for="item in productsList" :value="item.name" :key="item.id">{{ item.name }}</Option>
                    </Select>
                </FormItem>

                <!-- 优先级 -->
                <div v-if="patchBaselineForm.operatingSystem=='UBUNTU'">
                    <FormItem :label="$t('patch_management.patch_policy.priority')" prop="priority">
                        <Select v-model="patchBaselineForm.priority" multiple :max-tag-count="1" @on-change="priorityChange(patchBaselineForm.priority)" style="width:300px;" placeholder="">
                            <Checkbox v-model="singlePriority" @on-change="selectPriorityAll" style="display: block;text-align:right;">{{ $t('patch_management.patch_policy.selectAll') }} </Checkbox>
                            <Option v-for="item in priorityList" :value="item.name" :key="item.id">{{ item.name }}</Option>
                        </Select>
                    </FormItem>
                </div>

                <!-- 严重性 -->
                <div v-else>
                    <FormItem :label="$t('patch_management.patch_policy.severity')" prop="severity">
                        <Select v-model="patchBaselineForm.severity" multiple :max-tag-count="1" @on-change="severityChange(patchBaselineForm.severity)" style="width:300px;" placeholder="">
                             <Checkbox v-model="singleSeverity" @on-change="selectSeverityAll" style="display: block;text-align:right;">{{ $t('patch_management.patch_policy.selectAll') }} </Checkbox>
                            <Option v-for="item in severityList" :value="item.name" :key="item.id">{{ item.name }}</Option>
                        </Select>
                    </FormItem>
                </div>

                <!-- 描述 -->
                <FormItem :label="$t('patch_management.patch_policy.description')" prop="describe">
                    <Input v-model="patchBaselineForm.describe" type="textarea" :autosize="{minRows: 2,maxRows: 5}" placeholder="" style="width:300px;"></Input>
                </FormItem>
            </Form>
        </Modal>
    </div>
</template>
<script>
    var tablePatchBaselineVue = {}
    export default {
        inject:['reload'],
        data () {
            return {
                loading: true,
                modal:false,
                singleProducts:false,
                singlePriority:false,
                singleSeverity:false,
                accountIdList:[], //账号
                regionList:[], //区域
                severityList:[],
                operatingSystemList:[{
                    id:0,
                    name:'Amazon Linux',
                    operatingName:'AMAZON_LINUX'
                },{
                    id:1,
                    name:'Amazon Linux 2',
                    operatingName:'AMAZON_LINUX_2'
                },{
                    id:2,
                    name:'CentOS',
                    operatingName:'CENTOS'
                },{
                    id:3,
                    name:'Red Hat Enterprise Linux',
                    operatingName:'REDHAT_ENTERPRISE_LINUX'
                },{
                    id:4,
                    name:'SUSE',
                    operatingName:'SUSE'
                },{
                    id:5,
                    name:'Ubuntu',
                    operatingName:'UBUNTU'
                },{
                    id:6,
                    name:'Windows',
                    operatingName:'WINDOWS'
                }],
                productsList:[],
                priorityList:[],
                patchBaselineForm: {
                    name:'',
                    operatingSystem:'WINDOWS',
                    products:[],
                    priority:[],
                    severity:[],
                    isDefault:'true',
                    describe:'',
                    accountIdSearchKey:'',
                    regionSearchKey:''
                },
                isDefaultList: [{
                    label: this.$t('patch_management.patch_policy.yes'),
                    value: 'is',
                    isDefault: 'true'
                },{
                    label: this.$t('patch_management.patch_policy.no'),
                    value: 'no',
                    isDefault: 'false'
                }],
                ruleValidate: {
                    name: [
                        { required: true, message: '名称不能为空', trigger: 'blur' }
                    ],
                    operatingSystem: [
                        { required: true, message: '请选择操作系统', trigger: 'change'}
                    ],
                    products: [
                        { required: true, message: '请选择产品', trigger: 'change',type: 'array'}
                    ],
                    priority: [
                        { required: true, message: '请选择优先级', trigger: 'change',type: 'array'}
                    ],
                    severity: [
                        { required: true, message: '请选择严重性', trigger: 'change',type: 'array'}
                    ],
                    describe: [
                        { required: true, message: '请输入描述', trigger: 'blur'},
                        { type: 'string', max: 1000, message: '最多输入1000个字符', trigger: 'blur' }
                    ],
                    isDefault: [
                        { required: true, message: '请选择是否默认补丁基准', trigger: 'change' }
                    ],
                    accountIdSearchKey: [
                        { required: true, message: this.$t('alarms.common.pleaseSelectAccount'), trigger: 'change',type:'number' }
                    ],
                    regionSearchKey: [
                        { required: true, message: this.$t('RAM.common.PleaseSelectRegion'), trigger: 'change' }
                    ]
                }
            }
        },

        beforeCreate: function () {
            tablePatchBaselineVue = this
        },
        methods:{
            init: function(id){
                this.patchBaselineForm.id = id || 0;
                // 产品和优先级
                tablePatchBaselineVue.getPatchBaselineInfo();
                this.$nextTick(() => {
                    // 重置表单
                    this.$refs['patchBaselineForm'].resetFields();
                })
                this.modal=true;
            },
            /******************所有全选*******************************************************/
            /***********产品**************************/
            selectProductsAll() {
                this.patchBaselineForm.products = []
                if (this.singleProducts) {
                    this.productsList.map((item) => {
                        this.patchBaselineForm.products.push(item.name)
                    })
                } else {
                    this.patchBaselineForm.products = []
                }
            },
            // 切换产品
            productsChange(val) {
                if (val.length === this.productsList.length&&val.length!=0) {
                    this.singleProducts = true
                } else {
                    this.singleProducts = false
                }
            },
            /***********优先级**************************/
            selectPriorityAll() {
                this.patchBaselineForm.priority = []
                if (this.singlePriority) {
                    this.priorityList.map((item) => {
                        this.patchBaselineForm.priority.push(item.name)
                    })
                } else {
                    this.patchBaselineForm.priority = []
                }
            },
            // 切换优先级
            priorityChange(val) {
                if (val.length === this.priorityList.length&&val.length!=0) {
                    this.singlePriority = true
                } else {
                    this.singlePriority = false
                }
            },
            /***********严重性**************************/
            selectSeverityAll() {
                this.patchBaselineForm.severity = []
                if (this.singleSeverity) {
                    this.severityList.map((item) => {
                        this.patchBaselineForm.severity.push(item.name)
                    })
                } else {
                    this.patchBaselineForm.severity = []
                }
            },
            // 切换优先级
            severityChange(val) {
                if (val.length === this.severityList.length&&val.length!=0) {
                    this.singleSeverity = true
                } else {
                    this.singleSeverity = false
                }
            },
            /**********************账号********************************/
            // 切换账号
            changeAccountId: function(){
                this.regionList = [];
                this.patchBaselineForm.priority=[];
                this.patchBaselineForm.severity=[];
                this.patchBaselineForm.products=[];
                this.patchBaselineForm.regionSearchKey = ''
                tablePatchBaselineVue.getPatchBaselineInfo();
            },
            /**********************区域********************************/
            // 切换区域
            changeRegionSearchKey: function(){
                this.patchBaselineForm.priority=[];
                this.patchBaselineForm.severity=[];
                this.patchBaselineForm.products=[];
                tablePatchBaselineVue.getPatchBaselineInfo();
            },
             /**********************操作系统********************************/
            // 切换操作系统
            changeOperatingSystem: function(){
                this.patchBaselineForm.priority=[];
                this.patchBaselineForm.severity=[];
                this.patchBaselineForm.products=[];
                tablePatchBaselineVue.getPatchBaselineInfo();
            },
            /**********************产品和优先级********************************/
            //查询产品和优先级
            getPatchBaselineInfo: function(){
                this.$api.policy.getPatchBaselineInfo({
                    "awssmPatcheRequestDTO" : {
                        "operatingSystem" : this.patchBaselineForm.operatingSystem
                    },
                    "accountId" : this.patchBaselineForm.accountIdSearchKey,
                    "regionString" : this.patchBaselineForm.regionSearchKey
                })
                .then(res => {
                    if (this.patchBaselineForm.accountIdSearchKey != '' && (this.patchBaselineForm.regionSearchKey != '' && this.patchBaselineForm.regionSearchKey != undefined)) {
                        // 严重性
                        this.severityList=res.data.severtyList;
                        // 产品
                        this.productsList = res.data.productList;
                        // 优先级
                        this.priorityList = res.data.priorityList;
                    } else {
                        if (this.patchBaselineForm.accountIdSearchKey == '' || this.patchBaselineForm.accountIdSearchKey == null) {
                            // 账号
                            this.accountIdList=res.data.accounts;
                        } else if (this.patchBaselineForm.regionSearchKey == '' || this.patchBaselineForm.regionSearchKey == undefined) {
                            // 区域
                            this.regionList=res.data.regions;
                        }
                    }
                })
            },
            // 创建
            /**********************************************************************************/
            ok: function(name){
                this.$refs[name].validate(valid => {
                    if(valid){
                        if(this.patchBaselineForm.id>0){
                            // 编辑
                        }else{
                            // 添加
                            this.$api.policy.createPatchBaseline({
                                "awssmPatcheRequestDTO" : {
                                    "name" : this.patchBaselineForm.name,
                                    "description" : this.patchBaselineForm.describe,
                                    "operatingSystem" : this.patchBaselineForm.operatingSystem,
                                    "products": this.patchBaselineForm.products,
                                    "severities" : this.patchBaselineForm.severity,
                                    "priorities":this.patchBaselineForm.priority
                                },
                                "accountId" : this.patchBaselineForm.accountIdSearchKey,
                                "regionString" : this.patchBaselineForm.regionSearchKey,
                                "isDefaultPatchBaseline": this.patchBaselineForm.isDefault
                            })
                            .then(res => {
                                setTimeout(() => {
                                    this.$refs[name].resetFields();
                                    this.loading = false;
                                    this.$nextTick(() => {
                                        this.loading = true;
                                    });
                                    this.$Message.success('添加成功');
                                    this.patchBaselineForm.priority=[];
                                    this.patchBaselineForm.severity=[];
                                    this.patchBaselineForm.products=[];
                                    this.modal = false;
                                },1000);
                            })
                        }

                    }else{
                        //解决iview 表单验证，验证提示error完成验证后，"确定"按钮一直转圈，点击不起作用问题
                        this.loading = false;
                        setTimeout(() => {
                            this.loading = true
                        }, 0)
                        if(this.patchBaselineForm.id>0){
                            this.$Message.error('编辑失败');
                        }else{
                            this.$Message.error('添加失败');
                        }
                    }
                });
            },
            // 取消
            cancel: function(name){
                this.productsList=[];
                this.priorityList=[];
                this.severityList=[];
                this.singleProducts=false;
                this.singlePriority=false;
                this.singleSeverity=false;
                this.$nextTick(() => {
                    this.$refs[name].resetFields();
                });
                this.modal=false;
            }
        }
    }
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/patch_management/policy/patch_baseline_configuration/AddOrUpdatePatchBaseline.vue